"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getErrorMessage = void 0;
function getErrorMessage(error) {
    let message = '';
    if (error === null || error === void 0 ? void 0 : error.message) {
        message = error.message;
    }
    else if (error === null || error === void 0 ? void 0 : error.code) {
        message = error.code;
        message +=
            '\n\nDatum a čas: ' +
                (error.timestamp
                    ? new Date(error.timestamp).toLocaleString()
                    : new Date().toLocaleString());
        if (error === null || error === void 0 ? void 0 : error.details) {
            message += '\n\n' + JSON.stringify(error === null || error === void 0 ? void 0 : error.details, null, 3);
        }
    }
    return message;
}
exports.getErrorMessage = getErrorMessage;
//# sourceMappingURL=error-utils.js.map